/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductCategory } from './ProductCategory';
// @ts-ignore
import {
// @ts-ignore
    ProductCategoryFromJSON,
// @ts-ignore
    ProductCategoryFromJSONTyped,
// @ts-ignore
    ProductCategoryToJSON,
} from './ProductCategory';

/**
 * 
 * @export
 * @interface ProductCategoryListResponse
 */
export interface ProductCategoryListResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<ProductCategory>}
     * @memberof ProductCategoryListResponse
     */
    items: Array<ProductCategory>;
}

/**
 * Check if a given object implements the ProductCategoryListResponse interface.
 */
// @ts-ignore
export function instanceOfProductCategoryListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function ProductCategoryListResponseFromJSON(json: any): ProductCategoryListResponse {
    return ProductCategoryListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductCategoryListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategoryListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(ProductCategoryFromJSON)),
    };
}

// @ts-ignore
export function ProductCategoryListResponseToJSON(value?: ProductCategoryListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(ProductCategoryToJSON)),
    };
}

